import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import DashboardLayout from '@/components/layouts/dashboard';
import ShipLoading from '@/components/ui/loader/ShipLoading';

export default function SettingsPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace('/dashboard#settings');
  }, [router]);

  return (
    <DashboardLayout>
      <div className="w-full flex items-center justify-center min-h-[50vh]">
        <ShipLoading label="Memuat pengaturan..." />
      </div>
    </DashboardLayout>
  );
}

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
});
